<template>
  <div>
    <LandingPageOriginal v-if="showOriginal" />
    <LandingPageV2 v-else-if="showVersionTwo" />
    <LandingPageV3 v-else-if="showVersionThree" />
    <LandingPageV4 v-else />
  </div>
</template>

<script>
import LandingPageOriginal from './LandingPageOriginal.vue'
import LandingPageV2 from './LandingPageV2.vue'
import LandingPageV3 from './LandingPageV3.vue'
import LandingPageV4 from './LandingPageV4.vue'

export default {
  name: 'LandingPageVersions',
  components: {
    LandingPageOriginal, LandingPageV2, LandingPageV3, LandingPageV4,
  },
  computed: {
    showOriginal() { return ['original', '1'].includes(this.$route.query.version) },
    showVersionTwo() { return this.$route.query.version === '2' },
    showVersionThree() { return this.$route.query.version === '3' },
  },
}
</script>
